import { ReactNode, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

type ProtectedRouteProps = {
  readonly children: ReactNode;
  readonly roles: readonly string[];
};

export default function ProtectedRoute({ children, roles }: ProtectedRouteProps) {
  const [role, setRole] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    import("@/lib/auth")
      .then(({ getCurrentUserRole }) => getCurrentUserRole())
      .then(setRole)
      .catch(() => setRole(null));
  }, []);

  if (role === undefined) {
    return (
      <main className="grid min-h-screen place-items-center bg-background" aria-busy="true">
        <p className="text-muted-foreground">Checking your secure session…</p>
      </main>
    );
  }

  if (!role || !roles.includes(role)) {
    return <Navigate to={`/login/${roles[0]}`} replace />;
  }

  return <>{children}</>;
}
